import { BuildInfo } from '../../constants/buildInfo.constant'
import { Injectable } from '@angular/core'

@Injectable({
    providedIn: 'root'
})
export class IntercomService {

    loginUser(username, name): void {
        if (!BuildInfo.intercomAppId) {
            return
        }
        // @ts-ignore
        window.Intercom('boot', {
            app_id: BuildInfo.intercomAppId,
            email: username,
            user_id: username,
            name: name
        })
    }

    shutdown(): void {
        // @ts-ignore
        window.Intercom('shutdown')
    }
}
